import Placeholder from './Placeholder'

export default Placeholder;
